module.exports = __webpack_public_path__ + "img/29cc69462663a1c8b50a7e8c363dcad.af95c017.png";